import axios from '@/axiosInstance';
import { RegisterPayload, RegisterResponse, User } from '@oare/types';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '@/firebase';

async function register(payload: RegisterPayload): Promise<User> {
  const { data }: { data: RegisterResponse } = await axios.post(
    '/register',
    payload
  );
  await signInWithCustomToken(auth, data.firebaseToken);
  return data.user;
}

export default { register };
